import {REHYDRATE} from 'redux-persist';
import wellknown from 'wellknown';

const commodities = [
  {
    label: 'Corn',
    value: 'Corn',
  },
  /*
  {
    label: 'Milo',
    value: 'Milo',
  },
  */
  {
    label: 'Soybean',
    value: 'Soybean',
  },
  /*
  {
    label: 'Soybean Meal',
    value: 'Soybean Meal',
  },
  {
    label: 'Wheat',
    value: 'Wheat',
  },
  */
];

const initialState = {
  selectedCropYear: '',
  selectedCommodity: 'Corn',
  cropYearsDropDownListDataSource: [],
  commoditiesDropDownListDataSource: [],
  mappedFarmFields: [],
  nonHarvestedMappedFarmFields: [],
  fetchingFarmFields: false,
  mappedDigiFarmFields: [],
  selectedMappedFarmField: null,
  clearMappedFarmFieldPolygons: false,
  showDrawFieldBoundaryControls: false,
  nonMappedFarmFields: [],
  fetchingDigiFarmFields: false,
  nonMappedDigiFarmFields: [],
  nonMappedHiResDigiFarmFields: [],
  selectedNonMappedFarmField: null,
  selectedNonMappedDigiFarmFields: [],
  submittingNonMappedFarmFields: false,
  successfullySubmittedNonMappedFarmFields: [],
  clearPriorGoogleMappingSession: true,
  userDrawnShapes: [],
  userTappedResetDrawingCount: 0,
  mapMyFieldsSuccessModalIsVisible: false,
  mappedFarmFieldsList: [],
  fetchingMappedFarmFieldsList: false,
  selectedNetOfFreightFarmField: null,
  fetchingNetOfFreightLocations: false,
  netOfFreightLocations: [],
  netOfFreightSelectedCommodity: 'Corn',
  netOfFreightCommoditiesDropDownListDataSource: commodities,
  netOfFreightPerMileCost: '0.0025',
  netOfFreightTruckBaseRate: '0.10',
  userDraggedOrigin: null,
  fetchingFarmFieldsWithNutrientRemoval: false,
  farmFieldsWithNutrientRemoval: [],
  selectedFarmFieldWithNutrientRemoval: null,
};

export default function reducer(state = initialState, action = {}) {

  switch (action.type) {

    case REHYDRATE:
      if (action.payload) {
        return {
          ...state,
          ...action.payload.mapping,
          selectedCropYear: '',
          selectedCommodity: 'Corn',
          cropYearsDropDownListDataSource: [],
          commoditiesDropDownListDataSource: [],
          mappedFarmFields: [],
          nonHarvestedMappedFarmFields: [],
          fetchingFarmFields: false,
          mappedDigiFarmFields: [],
          selectedMappedFarmField: null,
          clearMappedFarmFieldPolygons: false,
          showDrawFieldBoundaryControls: false,
          nonMappedFarmFields: [],
          fetchingDigiFarmFields: false,
          nonMappedDigiFarmFields: [],
          nonMappedHiResDigiFarmFields: [],
          selectedNonMappedFarmField: null,
          selectedNonMappedDigiFarmFields: [],
          submittingNonMappedFarmFields: false,
          successfullySubmittedNonMappedFarmFields: [],
          clearPriorGoogleMappingSession: false,
          userDrawnShapes: [],
          userTappedResetDrawingCount: 0,
          mapMyFieldsSuccessModalIsVisible: false,
          mappedFarmFieldsList: [],
          fetchingMappedFarmFieldsList: false,
          selectedNetOfFreightFarmField: null,
          fetchingNetOfFreightLocations: false,
          netOfFreightLocations: [],
          netOfFreightSelectedCommodity: 'Corn',
          netOfFreightCommoditiesDropDownListDataSource: commodities,
          netOfFreightPerMileCost: '0.0025',
          netOfFreightTruckBaseRate: '0.10',
          userDraggedOrigin: null,
          fetchingFarmFieldsWithNutrientRemoval: false,
          farmFieldsWithNutrientRemoval: [],
          selectedFarmFieldWithNutrientRemoval: null,
        };
      }
      return state;

    case 'INIT_MY_FIELDS_INTERFACE':
      return {
        ...state,
        selectedCropYear: '',
        selectedCommodity: 'Corn',
        cropYearsDropDownListDataSource: [],
        commoditiesDropDownListDataSource: [],
        mappedFarmFields: [],
        nonHarvestedMappedFarmFields: [],
        fetchingFarmFields: true,
        mappedDigiFarmFields: [],
        selectedMappedFarmField: null,
      };

    case 'FETCHED_CURRENT_CROP_YEAR':
      return {
        ...state,
        selectedCropYear: action.currentCropYear[0].CropYear,
      };

    case 'FETCHED_CROP_YEARS':
      var cropYearsDropDownListDataSource = [];
      action.cropYears.forEach((cropYear) => {
        cropYearsDropDownListDataSource.push({
          label: cropYear.CropYear,
          value: cropYear.CropYear,
        });
      });
      return {
        ...state,
        cropYearsDropDownListDataSource: cropYearsDropDownListDataSource,
      };

    case 'FETCHED_COMMODITIES':
      var commoditiesDropDownListDataSource = [];
      action.commodities.forEach((commodity) => {
        commoditiesDropDownListDataSource.push({
          label: commodity.CommodityId,
          value: commodity.CommodityId,
        });
      });
      return {
        ...state,
        commoditiesDropDownListDataSource: commoditiesDropDownListDataSource,
      };

    case 'FETCH_FARM_FIELDS_STARTED':
      return {
        ...state,
        fetchingFarmFields: true,
        selectedMappedFarmField: null,
      };

    case 'FETCHED_MAPPED_FARM_FIELDS':
      var selectedMappedFarmField = null;
      action.mappedFarmFields.forEach(field => {
        field.GoogleMapFieldPolygons = [];
        const polygons = wellknown.parse(field.FieldPolygon);
        polygons.coordinates.forEach(polygonCoordinates => {
          var polygonCoords = [];
          if (polygons.type === 'MultiPolygon') {
            polygonCoordinates[0].forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          else {
            polygonCoordinates.forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          field.GoogleMapFieldPolygons.push(polygonCoords);
        });
        if (field.FieldId === state.selectedMappedFarmField?.FieldId) {
          selectedMappedFarmField = field;
        }
      });
      const mappedFarmFields = action.mappedFarmFields.filter(field => field.Commodity !== undefined);
      const nonHarvestedMappedFarmFields = action.mappedFarmFields.filter(field => field.Commodity === undefined);
      if (selectedMappedFarmField === null && mappedFarmFields.length > 0) {
        selectedMappedFarmField = mappedFarmFields[0];
      }
      return {
        ...state,
        fetchingFarmFields: false,
        mappedFarmFields: mappedFarmFields,
        nonHarvestedMappedFarmFields: nonHarvestedMappedFarmFields,
        selectedMappedFarmField: selectedMappedFarmField,
      };

    case 'FETCHING_FARM_FIELDS_FAILED':
      return {
        ...state,
        fetchingFarmFields: false,
      };

    case 'USER_SELECTED_CROP_YEAR':
      return {
        ...state,
        selectedCropYear: action.selectedCropYear,
      };

    case 'USER_SELECTED_COMMODITY':
      return {
        ...state,
        selectedCommodity: action.selectedCommodity,
      };

    case 'USER_SELECTED_MAPPED_FARM_FIELD':
      return {
        ...state,
        clearMappedFarmFieldPolygons: false,
        selectedMappedFarmField: action.selectedMappedFarmField,
      };

    case 'FETCHED_DIGIFARM_FARM_FIELDS_FOR_MAPPED_FIELDS_INTERFACE':
      return {
        ...state,
        mappedDigiFarmFields: action.digiFarmFields,
      };

    case 'CLEAR_MAPPED_FARM_FIELD_POLYGONS':
      return {
        ...state,
        clearMappedFarmFieldPolygons: true,
      };

    case 'INIT_MAP_MY_FIELDS_INTERFACE':
      return {
        ...state,
        showDrawFieldBoundaryControls: false,
        nonMappedFarmFields: [],
        fetchingDigiFarmFields: false,
        nonMappedDigiFarmFields: [],
        nonMappedHiResDigiFarmFields: [],
        selectedNonMappedFarmField: null,
        selectedNonMappedDigiFarmFields: [],
        submittingNonMappedFarmFields: false,
        clearPriorGoogleMappingSession: false,
        userDrawnShapes: [],
        userTappedResetDrawingCount: 0,
        mapMyFieldsSuccessModalIsVisible: false,
      };

    case 'FETCHED_NON_MAPPED_FARM_FIELDS':
      return {
        ...state,
        nonMappedFarmFields: action.nonMappedFarmFields,
        fetchingFarmFields: false,
      };

    case 'USER_TAPPED_DRAW_FIELD_BOUNDARIES':
      return {
        ...state,
        showDrawFieldBoundaryControls: !state.showDrawFieldBoundaryControls,
      };

    case 'USER_SELECTED_NON_MAPPED_FARM_FIELD':
      return {
        ...state,
        selectedNonMappedFarmField: action.selectedNonMappedFarmField,
      };

    case 'USER_REQUESTED_FETCH_DIGIFARM_FARM_FIELDS':
      return {
        ...state,
        fetchingDigiFarmFields: true,
      };

    case 'FETCHED_DIGIFARM_FARM_FIELDS_FOR_NON_MAPPED_INTERFACE':
      return {
        ...state,
        nonMappedDigiFarmFields: action.digiFarmFields,
        fetchingDigiFarmFields: false,
      };

    case 'FETCHED_HI_RES_NON_MAPPED_DIGIFARM_FARM_FIELDS':
      return {
        ...state,
        nonMappedHiResDigiFarmFields: action.nonMappedHiResDigiFarmFields,
      };

    case 'FETCH_DIGIFARM_FARM_FIELDS_FAILED':
      return {
        ...state,
        fetchingDigiFarmFields: false,
      };

    case 'SUBMIT_NON_MAPPED_FARM_FIELDS_STARTED':
      return {
        ...state,
        submittingNonMappedFarmFields: true,
      };

    case 'SUBMITTED_NON_MAPPED_FARM_FIELDS_SUCCESSFULLY':
      state.successfullySubmittedNonMappedFarmFields.push(action.selectedNonMappedFarmField);
      return {
        ...state,
        submittingNonMappedFarmFields: false,
        successfullySubmittedNonMappedFarmFields: [...state.successfullySubmittedNonMappedFarmFields],
        selectedNonMappedFarmField: null,
        nonMappedDigiFarmFields: [...state.nonMappedDigiFarmFields],
        nonMappedHiResDigiFarmFields: [],
        clearPriorGoogleMappingSession: true,
        userDrawnShapes: [],
        userTappedResetDrawingCount: 0,
        mapMyFieldsSuccessModalIsVisible: true,
      };
    
    case 'SUBMIT_NON_MAPPED_FARM_FIELDS_FAILED':
      return {
        ...state,
        submittingNonMappedFarmFields: false,
      };

    case 'SET_GOOGLE_MAPPING_SESSION_CLEARED':
      return {
        ...state,
        clearPriorGoogleMappingSession: false,
      };

    case 'USER_DREW_SHAPE':
      state.userDrawnShapes.push(action.shape);
      return {
        ...state,
        userDrawnShapes: [...state.userDrawnShapes],
      };

    case 'USER_TAPPED_RESET_DRAWING':
      var count = state.userTappedResetDrawingCount + 1;
      return {
        ...state,
        userDrawnShapes: [],
        userTappedResetDrawingCount: count,
      };

    case 'SUBMIT_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_STARTED':
      return {
        ...state,
        submittingNonMappedFarmFields: true,
      };

    case 'SUBMITTED_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_SUCCESSFULLY':
      state.successfullySubmittedNonMappedFarmFields.push(action.selectedNonMappedFarmField);
      return {
        ...state,
        submittingNonMappedFarmFields: false,
        successfullySubmittedNonMappedFarmFields: [...state.successfullySubmittedNonMappedFarmFields],
        selectedNonMappedFarmField: null,
        clearPriorGoogleMappingSession: true,
        userDrawnShapes: [],
        userTappedResetDrawingCount: state.userTappedResetDrawingCount + 1,
        mapMyFieldsSuccessModalIsVisible: true,
      };

    case 'SUBMIT_NON_MAPPED_FARM_FIELDS_WITH_USER_DRAWING_FAILED':
      return {
        ...state,
        submittingNonMappedFarmFields: false,
      };

    case 'HIDE_MAP_MY_FIELDS_SUCCESS_MODAL':
      return {
        ...state,
        submittingNonMappedFarmFields: false,
        mapMyFieldsSuccessModalIsVisible: false,
      };

    case 'INIT_NET_OF_FREIGHT_INTERFACE':
      return {
        ...state,
        netOfFreightSelectedCommodity: 'Corn',
        mappedFarmFieldsList: [],
        fetchingMappedFarmFieldsList: true,
        selectedNetOfFreightFarmField: null,
        fetchingNetOfFreightLocations: false,
        netOfFreightLocations: [],
        netOfFreightPerMileCost: '0.0025',
        netOfFreightTruckBaseRate: '0.10',
        userDraggedOrigin: null,
      };

    case 'USER_SELECTED_NET_OF_FREIGHT_COMMODITY':
      return {
        ...state,
        netOfFreightSelectedCommodity: action.selectedCommodity,
      };

    case 'FETCHED_MAPPED_FARM_FIELDS_LIST':
      action.mappedFarmFieldsList.forEach(field => {
        field.GoogleMapFieldPolygons = [];
        const polygons = wellknown.parse(field.FieldPolygon);
        polygons.coordinates.forEach(polygonCoordinates => {
          var polygonCoords = [];
          if (polygons.type === 'MultiPolygon') {
            polygonCoordinates[0].forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          else {
            polygonCoordinates.forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          field.GoogleMapFieldPolygons.push(polygonCoords);
        });
      });
      return {
        ...state,
        mappedFarmFieldsList: action.mappedFarmFieldsList,
        fetchingMappedFarmFieldsList: false,
      };

    case 'FETCHING_MAPPED_FARM_FIELDS_LIST_FAILED':
      return {
        ...state,
        fetchingMappedFarmFieldsList: false,
      };

    case 'USER_SELECTED_NET_OF_FREIGHT_FARM_FIELD':
      return {
        ...state,
        clearMappedFarmFieldPolygons: false,
        selectedNetOfFreightFarmField: action.selectedNetOfFreightFarmField,
        userDraggedOrigin: null,
      };

    case 'FETCH_NET_OF_FREIGHT_LOCATIONS_STARTED':
      return {
        ...state,
        fetchingNetOfFreightLocations: true,
      };

    case 'FETCHED_NET_OF_FREIGHT_LOCATIONS':
      return {
        ...state,
        netOfFreightLocations: action.locations,
        fetchingNetOfFreightLocations: false,
      };

    case 'FETCHING_NET_OF_FREIGHT_LOCATIONS_FAILED':
      return {
        ...state,
        fetchingNetOfFreightLocations: false,
      }

    case 'USER_ENTERED_PER_MILE_COST':
      return {
        ...state,
        netOfFreightPerMileCost: action.perMileCost,
      };

    case 'USER_ENTERED_TRUCK_BASE_RATE':
      return {
        ...state,
        netOfFreightTruckBaseRate: action.truckBaseRate,
      };

    case 'SET_USER_DRAGGED_ORIGIN':
      return {
        ...state,
        userDraggedOrigin: action.position,
      };

    case 'FETCH_FARM_FIELDS_WITH_NUTRIENT_REMOVAL_STARTED':
      return {
        ...state,
        fetchingFarmFieldsWithNutrientRemoval: true,
        farmFieldsWithNutrientRemoval: [],
        selectedFarmFieldWithNutrientRemoval: null,
      };

    case 'FETCHED_FARM_FIELDS_WITH_NUTRIENT_REMOVAL':
      action.farmFieldsWithNutrientRemoval.forEach(field => {
        field.GoogleMapFieldPolygons = [];
        const polygons = wellknown.parse(field.FieldPolygon);
        polygons.coordinates.forEach(polygonCoordinates => {
          var polygonCoords = [];
          if (polygons.type === 'MultiPolygon') {
            polygonCoordinates[0].forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          else {
            polygonCoordinates.forEach(c => {
              polygonCoords.push({
                lat: c[1],
                lng: c[0],
              });
            });
          }
          field.GoogleMapFieldPolygons.push(polygonCoords);
        });
      });
      return {
        ...state,
        farmFieldsWithNutrientRemoval: action.farmFieldsWithNutrientRemoval,
        fetchingFarmFieldsWithNutrientRemoval: false,
      };

    case 'FETCHING_FARM_FIELDS_WITH_NUTRIENT_REMOVAL_FAILED':
      return {
        ...state,
        fetchingFarmFieldsWithNutrientRemoval: false,
      }

    case 'USER_SELECTED_FARM_FIELD_WITH_NUTRIENT_REMOVAL':
      return {
        ...state,
        selectedFarmFieldWithNutrientRemoval: action.selectedFarmFieldWithNutrientRemoval,
      };

    default:
      return state;
  }
}
